import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { Course, User } from '@shared/models';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmEditionModalComponent } from '@app/main/apps/course-detail/confirm-edition-modal/confirm-edition-modal.component';
import { CoursesAPIService } from './coursesApi.service';
import { Router } from '@angular/router';
import { SupervisorService } from './supervisor.service';
import { courseLabel } from '@shared/utils/wording.utils';

@Injectable()
export class ConcurrentEditionService {
  private _ws: ReconnectingWebSocket;
  private _currentUserId: string;
  private _dialogOpen = false;
  constructor(
    private _courseApiService: CoursesAPIService,
    private _dialog: MatDialog,
    private _router: Router,
    private _supervisorService: SupervisorService
  ) { }

  private closeWebSocket(): void {
    if (this._ws) {
      this._ws.close();
      this._ws = null;
    }
  }

  private goBack() { //method that works no matter how the module are implemented UNTIL the routes are redefined
    const segments = this._router.url.split('/');
    segments.pop()
    segments.pop();
    const parentUrl = segments.join('/') || '/';
    this._router.navigateByUrl(parentUrl);
  }


  private async showConcurrentEditingWarning(course: Course, editorUserId: string, forcedEntrance?: boolean) {
    if (this._dialogOpen) { return; } //only one dialog at a time
    const editorIsMe = this._currentUserId === editorUserId;
    let editor: User;
    if (!editorIsMe) {
      if (course.editing_user_id === editorUserId && !!course.editing_user) {
        editor = course.editing_user;
      } else {
        editor = await this._courseApiService.getUserById(editorUserId).toPromise();
      }
    }
    const dialogBox = this._dialog.open(ConfirmEditionModalComponent, {
      height: '155px',
      width: '400px',
      data: { label: courseLabel(course.experience_type), user: editor, isMe: editorIsMe, forcedEntrance: forcedEntrance }
    });
    this._dialogOpen = true;
    dialogBox.afterClosed().subscribe(result => {
      this._dialogOpen = false;
      if (result) {
        if (forcedEntrance) {
          this._supervisorService.askForCourseReload({ action: 'simple reload' });
        }
        return this.startEditingSession(course);
      }
      return this.goBack();

    });

  }

  private startEditingSession(course: Course) {
    this.closeWebSocket();
    const clientId = crypto.randomUUID();
    this._ws = new ReconnectingWebSocket(`${environment.coursesSocketUrl}?courseId=${course.id}&clientId=${clientId}`);
    this._ws.addEventListener('open', () => {
      this._ws.send(
        JSON.stringify({
          type: 'editing_request',
          data: {
            userId: this._currentUserId
          }
        })
      );
    });

    this._ws.addEventListener('message', (message: any) => {
      const messageObj = JSON.parse(message.data);
      if (messageObj.type === 'new_editor') {
        this.showConcurrentEditingWarning(course, messageObj.userId, true);
      }
    });
  }

  public enterEditingSession(course: Course, userId: string) {
    this._currentUserId = userId;
    if (course.editing_user_id) {
      this.showConcurrentEditingWarning(course, course.editing_user_id);
    } else {
      this.startEditingSession(course);
    };
  }

  public endEditingSession() {
    this.closeWebSocket();
  }
}
